// src/screens/Programacion/HistorialModal.jsx
import React from "react";

export default function HistorialModal({ historial, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
      <div className="bg-[#1e2a3a] text-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-8 shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-2xl font-bold text-gray-200 hover:text-red-400"
          aria-label="Cerrar historial"
        >
          ×
        </button>
        <h2 className="text-2xl font-bold mb-4">Historial de cambios</h2>
        {historial.length === 0 ? (
          <div className="text-gray-300 italic">No hay eventos aún.</div>
        ) : (
          <ul className="space-y-4">
            {historial
              .sort((a, b) => b.id - a.id)
              .map((evento) => (
                <li
                  key={evento.id}
                  className="border-l-4 border-blue-400 pl-4 py-2 bg-[#29394c] rounded"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-blue-300">
                      {evento.tipo}
                    </span>
                    <span className="text-xs text-gray-400">
                      {evento.fecha}
                    </span>
                  </div>
                  <div className="text-sm mt-1">
                    <div>
                      <b>Programación ID:</b> {evento.programacionId}
                    </div>
                    {evento.sectores && (
                      <div>
                        <b>Sectores:</b> {evento.sectores}
                      </div>
                    )}
                    <div>
                      <b>Detalles:</b> {evento.detalles}
                    </div>
                  </div>
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
}
